import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import Config from "../../../../../shared/src/ranj/app/config/Config";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import PuzzleRandomizer from "../util/PuzzleRandomizer";

export default class GameConfig extends Config {
    /**
     * @constructor
     * @param {AppModel} appModel 
     */
    constructor(appModel) {
        super();

        this._appModel = appModel;
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);

        if (getURLParameter("randomization") === "0") {
            console.log("GameConfig: Using fixed levels.");
            this._puzzles = this.getValue("puzzles");
            this._practicePuzzles = this.getValue("practicePuzzles");
        } else {
            console.log("GameConfig: Using random levels.");


            const ruleIndex = Math.floor(Math.random() * this.getValue("randomizedPuzzles")[0].randomizedRules.length);

            console.log("Rule Index: " + ruleIndex);

            this._puzzles = PuzzleRandomizer.generatePuzzle(
                this.getValue("randomizedPuzzles"),
                this.getValue("availablePuzzleLocations"),
                ruleIndex
            );
            
            this._practicePuzzles = PuzzleRandomizer.generatePuzzle(
                this.getValue("randomizedPracticePuzzles"),
                this.getValue("availablePracticePuzzleLocations"),
                ruleIndex
            );
            console.log("[Original Practice Puzzles]");
            console.log(this.getValue("practicePuzzles"));
            console.log("[New Practice Puzzles]");
            console.log(this._practicePuzzles);

            console.log("[Original Puzzles]");
            console.log(this.getValue("puzzles"));
            console.log("[New Puzzles]");
            console.log(this._puzzles);

            console.log("--------------------------");

            this._practicePuzzles.forEach(element => {
                console.log(`${element._comment}: ${element.rule.id[0]}`);
                
                element.rule.correctInput.forEach(function(item, index) {
                    console.log(`Correct Input: ${item}`);
            
                    element.sequence[index].forEach(item2 => {
                        console.log(`Spot: ${item2.spot} Amount: ${item2.variation.amount} Pattern: ${item2.variation.pattern}`);
                    });
                });
                
                console.log("---");
            });

            console.log("--------------------------");

            this._puzzles.forEach(element => {
                console.log(`${element._comment}: ${element.rule.id[0]}`);
                
                element.rule.correctInput.forEach(function(item, index) {
                    console.log(`Correct Input: ${item}`);
            
                    element.sequence[index].forEach(item2 => {
                        console.log(`Spot: ${item2.spot} Amount: ${item2.variation.amount} Pattern: ${item2.variation.pattern}`);
                    });
                });
                
                console.log("---");
            });
        }

    }

    get puzzles() {
        return this._puzzles;
    }
    
    get practicePuzzles() {
        return this._practicePuzzles;
    }

    getPracticePuzzle(idx, wrap = true) {
        if (wrap) {
            idx = idx % this.practicePuzzles.length
        }
        return this.practicePuzzles[idx];
    }

    getPuzzle(idx, wrap = true) {
        if (wrap) {
            idx = idx % this.puzzles.length
        }
        return this.puzzles[idx];
    }

    getLocation(index) {
        return this.getValue(`locations`)[index];
    }

    getLocationSkin(index) {
        return this.getLocation(index).skin;
    }

    getItemName(index) {
        return this.getValue(`items`)[index];
    }

}